export const getProviderReferenceLabel = (value, currency = false) => (Array.isArray(value) ? value : [value])
  .map(item => currency ? item?.currency_code || item?.code : item?.code).filter(Boolean).join(', ');

export const getProviderCategoryLabels = provider => {
  const { category, sub_category: subCategory } = provider?.provider_id || {};
  const gatewayCategories = Array.isArray(provider?.category) ? provider.category.map(item => item.name || item.code).filter(Boolean).join(', ') : '';
  return {
    category: gatewayCategories || category?.name || category?.code || '',
    subCategory: subCategory?.name || subCategory?.code || ''
  };
};

export const getProviderCategoryContext = provider => {
  const { category, subCategory } = getProviderCategoryLabels(provider);
  if (Array.isArray(provider?.category)) return `Category: ${category || '-'}`;
  return `Category: ${category || '-'} · Subcategory: ${subCategory || '-'}`;
};
